import { makeObservable } from 'mobx';
import { Filtro } from './Filtro';

export default class FiltroImpedimentosMagistrado extends Filtro {
    tipo = 'selecao';
    exibicao = 'select';
    selecaoMultipla = true;

    static LABEL_MAGISTRADOS_NAO_IDENTIFICADOS = '\u0001NÃO IDENTIFICADOS'; // caractere para forçar que apareça primeiro na ordenação alfabética

    static CAMPO_LABEL = {
        SIGLA: 'sigla',
        NOME: 'nome'
    };

    get label() {
        return 'Impedimento por magistrado';
    }

    constructor(props) {
        super(props);
        makeObservable(this);
    }

    getValorOpcao(registro) {
        return this._magistradosImpedidos(registro.impedimentos, FiltroImpedimentosMagistrado.CAMPO_LABEL.NOME) ?? [];
    }

    _magistradosImpedidos = (impedimentos, campo) => {
        return (
            impedimentos?.map(
                (impedimento) =>
                    impedimento.magistrado?.[campo] ?? FiltroImpedimentosMagistrado.LABEL_MAGISTRADOS_NAO_IDENTIFICADOS
            ) || []
        );
    };
}
